var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"opration-btn"},_vm._l((_vm.oprationMenu),function(item,index){return _c('div',{key:index,staticClass:"btn-item",on:{"click":function($event){return _vm.goLink(item)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }